import cn from "classnames";
import { t } from "i18next";

import { TableItemStatusProps } from "./TableItemStatus.types";

import styles from "./TableItemStatus.module.scss";

const TableItemStatus = ({
  activeStatusIndex,
  statusesList,
  className,
  fullWidth
}: TableItemStatusProps) => {
  return (
    <div
      className={cn(styles.statusControlContainer, {
        [styles.statusControlContainer__fullWidth]: fullWidth
      })}
    >
      <div
        className={cn(
          styles.activeStatusBtn,
          { [styles.activeStatusBtn__fullWidth]: fullWidth },
          className
        )}
        style={{
          backgroundColor: statusesList[activeStatusIndex]?.backgroundColor
        }}
      >
        {t(statusesList[activeStatusIndex]?.label)}
      </div>
    </div>
  );
};

export default TableItemStatus;
